(function () {
    'use strict';

    angular
		.module('app')
		.controller('userTheme', ['$scope', 'plmThemes', function ($scope, plmThemes) {
		    $scope.theme = plmThemes.getThemes();
		    $scope.themeStyle = $scope.$root.theme;
		}])
		.controller('SystemMessageEditController', systemMessageEditController);

    function systemMessageEditController($scope, $http, $cookies, $location, $rootScope, $timeout, $interval, $state, $stateParams, $filter, SystemMessageService, cfpLoadingBar, toaster) {

        var model = this;

        ///////////////////////
        ////// for VUE ////////
        ///////////////////////

        $scope.systemMessageList = function (id) {
            $state.go('systemMessageList');
        };

        $scope.permissionDenied = function () {
            $state.go('permissionDenied');
        }

        $scope.messageId = $stateParams.id;


        ///////////////////////
        ///// end for VUE /////
        ///////////////////////

        model.id = $stateParams.id;
        model.message = {};
        model.customValidationValid = true;

        model.checkPermissions = function () {
            angular.forEach($rootScope.userPermissions,
				function (userPermissionRow) {
				    if (userPermissionRow[0] === 18) {
				        if (userPermissionRow[1] === 2) {
				            model.SystemMessageEdit = true;
				        }
				    }
				});

            if (!model.SystemMessageEdit) {
                $state.go('permissionDenied');
                return false;
            }
            return true;
        };

        model.Save = function (isFormInvalid, r) {
            model.fireCustomValidation();
            if (model.customValidationValid && !isFormInvalid) {
                var msg = {};
                var StartTime = model.affixTime(model.message.StartDate, model.message.StartTime);
                var ExpireTime = model.affixTime(model.message.ExpireDate, model.message.ExpireTime);

                msg.StartTime = StartTime;
                msg.ExpireTime = ExpireTime;
                msg.ShowUnauthenticatedUsers = model.message.ShowUnauthenticatedUsers;
                msg.ShowFactoryUsers = model.message.ShowFactoryUsers;
                msg.Title = model.message.Title;
                msg.Message = model.message.Message;
                msg.SystemMessageId = model.id;

                SystemMessageService.updateMessage(msg)
					.then(function (response) {
					    if (response.IsSuccessful) {
					        model.id = response;
					        model.showSuccess('Record Saved Successfully.');
					        $scope.messageForm.$setPristine();
					        $scope.messageForm.$setUntouched();
					        if (r) {
					            $state.go('systemMessageList');
					        }
					    } else {
					        model.showError('There was an error while updating the message. Please contact system administrator.');
					        $scope.messageForm.$setPristine();
					        $scope.messageForm.$setUntouched();
					    }
					    
					},
						function (e) {
						    model.showError('There was an error while updating the message. Please contact system administrator.');
						    $scope.messageForm.$setPristine();
						    $scope.messageForm.$setUntouched();
						});
            } else {
                model.showError('Your submission contains error(s).  Please correct the highlighted items below.');
                angular.forEach($scope.messageForm.$invalid, function (field) { field.$setTouched(); });
            }
        };

        model.fireCustomValidation = function () {
            model.customValidationValid = true;
        };

        model.affixTime = function (date, time) {
            date = new Date(date);
            time = new Date(time);

            date.setHours(time.getHours());
            date.setMinutes(time.getMinutes());
            date.setSeconds(time.getSeconds());
            date = $filter('date')(date, 'MM/dd/yyyy HH:mm:ss');
            return date;
        };

        model.setTime = function (time,ampm) {
            var t = time.split(':');
            var h = ampm == 'PM' ? parseInt(t[0]) + 12 : t[0];
            var mm = t[1];
            var ss = '00';

            var date = new Date();
            date.setHours(h);
            date.setMinutes(mm);
            date.setSeconds(ss);

            return date;
        }

        model.getMessage = function () {
            model.message = null;
            SystemMessageService.getMessage(model.id).then(function (response) {
                if (response) {
                    model.message = response;
                    //need to split these out because they are edited in separate controls.
                    model.message.StartDate = model.message.StartTime;
                    model.message.ExpireDate = model.message.ExpireTime;
                } else {
                    model.showError('Message not found.');
                }
            },
			function () {
			    model.showError('There was an error retrieving system message data. Please contact system administrator.');
			});
        };

        model.showSuccess = function (msg) {
            model.showToast('success', 'Success!', msg);
        };

        model.showError = function (msg) {
            model.showToast('error', 'Error!', msg);
        };

        model.showToast = function (type, title, body) {
            toaster.pop({
                type: type,
                title: title,
                body: body,
                timeout: 5000
            });
        };

        var defaultStartTime = model.setTime('10:00', 'AM');
        var defaultEndTime = model.setTime('5:30', 'PM');

        model.defaultMessage = {
            StartDate: $filter('date')(new Date(), 'MM/dd/yyyy'),
            StartTime: defaultStartTime,
            ExpireDate: $filter('date')(new Date(), 'MM/dd/yyyy'),
            ExpireTime: defaultEndTime,
            ShowUnauthenticatedUsers: true,
            ShowFactoryUsers: true,
            Title: 'Temporary System Outage TODAY, ' + $filter('date')(defaultStartTime, 'h:mm a') + ' to ' + $filter('date')(defaultEndTime, 'h:mm a'),
            Message: 'Please save your work and refrain from using the system during this time.'
        }

        model.setDefaultMessage = function () {
            model.message = model.defaultMessage;
            cfpLoadingBar.complete();
        }

        if (model.checkPermissions() && model.id > 0) {
            model.getMessage();
        } else {
            model.setDefaultMessage();
        }

        model.deleteMessage = function (id) {
            SystemMessageService.deleteMessage(id).then(function (response) {
                if (response) {
                    $state.go('systemMessageList');
                    toaster.pop({
                        type: 'success',
                        title: 'Success!',
                        body: 'Message successfully deleted.',
                        timeout: 5000
                    });
                } else {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'Message not found.',
                        timeout: 5000
                    });
                }
            },
			function () {
			    toaster.pop({
			        type: 'error',
			        title: 'Error!',
			        body: 'There was an error deleting system message. Please contact system administrator.',
			        timeout: 5000
			    });
			});
        }
    }
})();
